import React from 'react';
import { Tr, Td } from 'react-super-responsive-table';
import PropTypes from 'prop-types';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import { TextField, Button } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';
import { CalendarToday } from '@mui/icons-material';
import { Grid, Chip, Avatar, styled, Box } from '@mui/material';
import { emptyString } from 'constants/defaultValues';

const OfferHistoryAvatar = styled(Avatar)(({ theme }) => ({
  width: theme.spacing(2.5),
  height: theme.spacing(2.5),
  backgroundColor: theme.palette.warning.main,
  '& span': {
    fontSize: '.8rem'
  }
}));

const OfferHistoryComponent = ({ offer }) => {
  const { t } = useTranslation();

  const getDirectCompensationIcon = offer => {
    return (
      offer.insuranceAmountWithDirectCompensation && (
        <OfferHistoryAvatar>
          <span>{t('Offer.Edit.OffersHistory.DirectSettlementCaption')}</span>
        </OfferHistoryAvatar>
      )
    );
  };

  return (
    <Tr>
      <Td>
        <span>{`${offer?.insurerName} / ${t('Offer.Edit.OffersHistory.Months', { period: offer?.period })}`}</span>
      </Td>
      <Td>{offer?.userName}</Td>
      <Td>
        <Chip
          size='small'
          icon={<CalendarToday />}
          label={`${t('DATE', { date: offer?.offerDate })} \n ${new Date(offer?.offerDate).toLocaleTimeString()}`}
        />
      </Td>
      <Td>
        <Grid container item justifyContent='center' spacing={1}>
          <Grid item xs={12} md={6}>
            <Button fullWidth disabled>
              <span style={{ height: '20px' }}>
                {offer.insuranceAmount ? t('Offer.Edit.OffersHistory.Currency', { amount: offer.insuranceAmount }) : '-'}
              </span>
            </Button>
          </Grid>
          <Grid item xs={12} md={6}>
            <Button fullWidth disabled startIcon={getDirectCompensationIcon(offer)}>
              {offer.insuranceAmountWithDirectCompensation
                ? t('Offer.Edit.OffersHistory.Currency', { amount: offer.insuranceAmountWithDirectCompensation })
                : '-'}
            </Button>
          </Grid>
        </Grid>
      </Td>
      <Td>
        <Box mx={1}>
          <TextField fullWidth multiline rows={2} variant='standard' disabled value={offer?.insurerErrors || emptyString} />
        </Box>
      </Td>
    </Tr>
  );
};

OfferHistoryComponent.propTypes = {
  offer: PropTypes.object.isRequired
};

export default OfferHistoryComponent;
